module.exports = __webpack_public_path__ + "static/media/Andy_24.e0d9209a.png";